import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { isAuthenticated, isAuthorized } from "@kdose/ng-auth";
import { NextaCanDeactivateCrudForm } from "./../../shared/nexta-crud/nexta-can-deactivate.guard";
import { CertificateFormComponent } from "./certificate-form.component";
import { CertificateListComponent } from "./certificate-list.component";
import { CertificateShowComponent } from "./certificate-show.component";

const certificateRoutes: Routes = [
	{
		path: "schluessel/zertifikate",
		component: CertificateListComponent,
		canActivate: [isAuthenticated, isAuthorized],
		data: {
			requiredAuthorizations: {
				oneOf: ["ADMIN"],
			},
		},
	},
	{
		path: "schluessel/zertifikate/neu",
		component: CertificateFormComponent,
		canDeactivate: [NextaCanDeactivateCrudForm],
		canActivate: [isAuthenticated, isAuthorized],
		data: {
			requiredAuthorizations: {
				oneOf: ["ADMIN"],
			},
		},
	},
	{
		path: "schluessel/zertifikate/:id",
		component: CertificateShowComponent,
		canActivate: [isAuthenticated, isAuthorized],
		data: {
			requiredAuthorizations: {
				oneOf: ["ADMIN"],
			},
		},
	},
];
@NgModule({
	imports: [RouterModule.forChild(certificateRoutes)],
	exports: [RouterModule],
})
export class CertificateRoutingModule {}
